import React from "react";
import i18n from "i18n";
import styles from "./MainApp.organisms.OrdersV3.Item-Tags.module.scss";
import defaultImage from "assets/images/default-image.png";

const ItemTagsV2 = ({
  item
}) => {
  return (
    <div className={styles["item-tag-container"]}>
      <div className={styles["item-tags-item"]}>
        <div className={styles["item-tags-item-image"]}>
          <img
            src={
              item.item_files?.length > 0
                ? item.item_files[0].file_name
                : defaultImage
            }
            alt={
              item.item_files?.length > 0 ? item.title : ""
            }
          />
        </div>
        <div>
          <div>
            <span className={styles["item-tags-item-title"]}>
              {item.title}
            </span>
          </div>
          <div>
            <span className={styles["item-tags-item-sku"]}>
              {item.sku}
            </span>
          </div>
        </div>
      </div>
      <div className={styles["tags-table-header"]}>
        <div>{i18n.t("epc")}</div>
        <div>{i18n.t("batch")}</div>
        <div>{i18n.t("expiry")}</div>
      </div>
      <div className={styles["item-tags-tags"]}>
        {item.tags.length > 0 &&
          item.tags.map((tag) => {
            return (
              <div key={tag.movement_item_id} className={styles["item-tag-row"]}>
                <div className={styles["item-tag-tag"]}>
                  {tag.tag}
                </div>
                <div className={styles["item-tag-batch"]}>
                  {/* {tag.batch || i18n.t("no_batch")} */}
                  {tag.batch || ""}
                </div>
                <div className={styles["item-tag-expiration"]}>
                  {tag.expiration_date &&
                    new Date(
                      tag.expiration_date
                    ).toLocaleDateString("es-ES", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric"
                    })}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default ItemTagsV2;
